export default __webpack_public_path__ + "img/blue.6abbe052.svg";